module.exports = __webpack_public_path__ + "img/friendsBg_02.561249d2.jpg";